import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { BiMessageAltError } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const TerrorismInformationCompanyComponent = ({ data }) => {
  const [company, setCompany] = useState(data);
  const [isEditing] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  const handleTerrorist = (e, data) => {
    e.preventDefault();
    navigate("/informe/terrorismo-pdf", { state: data });
  };

  return (
    <div className={styles.informacionPolitica} id="terrorismo">
      <div className={styles.sectionTitle2}>
        <div className={styles.sectionTitle3}>
          <h2 className={styles.sectionTitleH2}>Información Terrorismo</h2>
          <IconAnimation />
        </div>
        <div className="abmlistviewbutton">
          <button
            type="button"
            id="idbuttonabmviewlist"
            className="buttonviewñostabm"
            onClick={(e) => handleTerrorist(e, data)}
          >
            <i className="fa fa-refresh"></i> Terrorismo
            <FaArrowRight className={styles.icon} />
          </button>
        </div>
      </div>
      {!company || !company.PoliticalInformationCompany ? (
        <NotReportViewData
          title="Información Terrorismo"
          Icon={BiMessageAltError}
        />
      ) : (
        <>
          <label className={styles.inputLabel}>
            Resultado:
            <textarea
              className={styles.inputField}
              type="text"
              name="terrorismVerification"
              value={company.PoliticalInformationCompany.verification || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Verificación de terrorismo (DNI):
            <input
              className={styles.inputField}
              type="text"
              name="terrorismVerification"
              value={
                company.PoliticalInformationCompany.terrorismVerification || ""
              }
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
        </>
      )}
    </div>
  );
};

export default TerrorismInformationCompanyComponent;
